module.exports = __webpack_public_path__ + "img/RTB-front.1d5ec1ec.png";